import script from "./CartConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./CartConfirm.vue?vue&type=script&setup=true&lang=js"

import "./CartConfirm.vue?vue&type=style&index=0&id=84aae6f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84aae6f6"]])

export default __exports__